module.exports = __webpack_public_path__ + "static/the-undoing-project-0faf9c49595da1b19c1d5d19e4708388.jpg";